import { Component, OnInit } from "@angular/core"; import { Location, formatDate } from "@angular/common";
import { MessageService, ConfirmationService } from 'primeng/api';

import { DialogService } from 'primeng/dynamicdialog';
import { Router, ActivatedRoute } from '@angular/router';
import { CleValeurNumerique } from 'src/app/entites/cleValeur';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ProfilService } from 'src/app/services/profil-service';
import { Emplacement } from 'src/app/entites/emplacement';
import { EmployeEntite, enrichirRechercheEmploye } from 'src/app/entites/employe';
import { EStatuts } from 'src/app/entites/enums/statuts';
import { AppMainComponent } from 'src/app/app.main.component';
import { ContexteService } from 'src/app/services/contexte-service';
import { BaseComponent } from 'src/app/base/base-component';
import { BonTravailEntite } from 'src/app/entites/mecanique/bon-travail';
import { BonTravailService } from 'src/app/services/bon-travail-service';
import { ETypeBonTravail } from 'src/app/entites/enums/type-bon-travail';
import { ItemMin } from 'src/app/entites/item-min';
import { SelectionUniteMecaniqueComponent } from 'src/app/controles/mecanique/selection-unite-mecanique.component';
import { ReleveHeureEntite } from 'src/app/entites/releve-heures';
import { ReleveKmEntite } from 'src/app/entites/releve-kms';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { Fournisseur } from 'src/app/entites/fournisseur';
import { RaisonBonTravailEntite } from 'src/app/entites/mecanique/raison-bon-travail';
import { FournisseurService } from 'src/app/services/fournisseur-service';
import { ItemService } from 'src/app/services/item-service';

@Component({
    templateUrl: './ajout-bon-travail.component.html',
    styleUrls: ['./ajout-bon-travail.component.scss'],
    providers: [MessageService, ConfirmationService, DialogService]
})
export class AjoutBonTravailComponent extends BaseComponent implements OnInit {

    bonTravail: BonTravailEntite;
    itemId?: number;

    typesBonTravail: CleValeurNumerique[];
    selectionTypeBonTravail: CleValeurNumerique;

    dateBonTravail: Date;

    emplacements: Emplacement[];
    fournisseurs: Fournisseur[];
    raisons: RaisonBonTravailEntite[];
    listeEmployes: EmployeEntite[] = [];

    changementUnitePermis: boolean = true;
    dernierBonTravailRecent: BonTravailEntite;
    creationEnCours: boolean = false;

    private readonly moisRecentsBonTravail = 3;

    submitted: boolean = false;

    constructor(
        sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute,
        appMain: AppMainComponent, location: Location,
        private messageService: MessageService,
        private fournisseurService: FournisseurService,
        private bonTravailServie: BonTravailService,
        private itemService: ItemService,
        private contexteService: ContexteService,
        private breadcrumbService: BreadcrumbService,
        public dialogService: DialogService,
        public routerService: Router) {

        super(sdb, profilService, route, routerService, appMain);

        this.breadcrumbService.setItems([
            { label: 'Bons de travail', routerLink: '/mecanique/bontravails' },
            { label: 'Ajouter' }
        ]);

        this.route.params.subscribe(params => {
            this.itemId = params.id ? Number(params.id) : undefined;
        });
    }

    ngOnInit() {

        this.dateBonTravail = new Date();

        this.raisons = this.sdb.RaisonsBonTravail();

        this.emplacements = this.sdb.Emplacements();

        this.typesBonTravail = [
            { cle: ETypeBonTravail.Interne, valeur: "Interne" },
            { cle: ETypeBonTravail.Externe, valeur: "Externe" }
        ];
        this.selectionTypeBonTravail = this.typesBonTravail[0];

        this.listeEmployes = this.sdb.EmployesMecanique();
        this.listeEmployes.forEach(emp => enrichirRechercheEmploye(emp));

        this.bonTravail = {
            bonTravailId: 0,
            dateTravail: new Date(),
            dateCreation: new Date(),
            item: { itemId: 0 },
            emplacement: this.emplacements.find(x => x.emplacementId == 10000)
        };

        var p1 = new Promise<number | void>((resolve, reject) => {
            this.fournisseurService.ObtenirFournisseurs().then(x => {
                this.fournisseurs = x.valeur;
                resolve();
            });
        });

        var p2 = new Promise<number | void | void>((resolve, reject) => {
            if (this.itemId) {
                this.itemService.ObtenirItem(this.itemId).subscribe(item => {
                    var contreMaitre = null;
                    if (item.value().emplacement) {
                        this.bonTravail.emplacement = this.emplacements.find(x => x.emplacementId == item.value().emplacement.emplacementId);
                    }
                    if (item.value().departementMecanique && item.value().departementMecanique.contreMaitre) {
                        contreMaitre = this.listeEmployes.find(x => x.employeId == item.value().departementMecanique.contreMaitre.employeId)
                    }

                    this.bonTravail.contreMaitre = contreMaitre;
                    this.bonTravail.item = this.itemService.ItemVersItemMin(item.value());
                    this.chargerDernierBonTravailRecent(this.bonTravail.item.itemId);
                    resolve();
                });

            } else {
                resolve();
            }
        });

        Promise.all([p1, p2]).then(x => {

            this.CompleterChargement();

            if (this.bonTravail.item.itemId == 0) {
                this.rechercherUnite();
            }
        });
    }

    /**
     * Ouvre la sélection d'une unité mécanique.
     */
    rechercherUnite() {

        this.dialogService.open(SelectionUniteMecaniqueComponent, {
            header: 'Sélection d\'une unité',
            width: '95%'
        }).onClose.subscribe((res: ItemMin) => {
            if (res) {
                this.appliquerUniteSelectionnee(res);
            }
        });
    }

    /**
     * Applique l'unité sélectionnée et met à jour les champs dérivés.
     */
    appliquerUniteSelectionnee(item: ItemMin) {
        this.bonTravail.item = item;

        if (this.bonTravail.item.emplacement) {
            this.bonTravail.emplacement = this.emplacements.find(x => x.emplacementId == this.bonTravail.item.emplacement.emplacementId);
        }

        if (this.bonTravail.item.departementMecanique && this.bonTravail.item.departementMecanique.contreMaitre) {
            this.bonTravail.contreMaitre = this.listeEmployes.find(x => x.employeId == this.bonTravail.item.departementMecanique.contreMaitre.employeId)
        }

        this.chargerCompteursUnite(item.itemId);
        this.bonTravail.heuresDebutCompteur = undefined;
        this.bonTravail.kmDebutCompteur = undefined;
        this.bonTravail.releveHeureDebut = undefined;
        this.bonTravail.releveKmDebut = undefined;
        this.chargerDernierBonTravailRecent(item.itemId);
    }

    /**
     * Charge les heures et KM actuels de l'unité pour les placeholders de début.
     */
    chargerCompteursUnite(itemId: number) {
        if (!itemId) {
            return;
        }

        if (this.bonTravail.item?.heuresCompteur != null && this.bonTravail.item?.kmCompteur != null) {
            return;
        }

        this.itemService.ObtenirItem(itemId).subscribe(item => {
            const detail = item?.value();
            if (!detail || this.bonTravail.item?.itemId !== itemId) {
                return;
            }

            this.bonTravail.item = {
                ...this.bonTravail.item,
                heuresCompteur: detail.heuresCompteur,
                heuresReelles: detail.heuresReelles,
                kmCompteur: detail.kmCompteur,
                kmReel: detail.kmReel,
                indSuiviHeures: detail.indSuiviHeures,
                indSuiviKms: detail.indSuiviKms
            };
        });
    }

    /**
     * Charge le bon de travail le plus récent des derniers mois pour l'unité sélectionnée.
     */
    chargerDernierBonTravailRecent(itemId: number) {
        if (!itemId) {
            this.dernierBonTravailRecent = null;
            return;
        }

        this.bonTravailServie.ObtenirParItem(itemId).then(x => {
            if (!x.estUnSucces || !x.valeur?.length) {
                this.dernierBonTravailRecent = null;
                return;
            }

            const dateLimite = new Date();
            dateLimite.setMonth(dateLimite.getMonth() - this.moisRecentsBonTravail);

            const bonsRecents = x.valeur
                .filter(bdt => !bdt.indSoumission)
                .filter(bdt => {
                    const dateReference = new Date(bdt.dateCreation || bdt.dateTravail);
                    return !isNaN(dateReference.getTime()) && dateReference >= dateLimite;
                })
                .sort((a, b) =>
                    new Date(b.dateCreation || b.dateTravail).getTime() -
                    new Date(a.dateCreation || a.dateTravail).getTime());

            this.dernierBonTravailRecent = bonsRecents[0] ?? null;
        });
    }

    /**
     * Texte d'avertissement lorsque l'unité possède déjà un bon de travail dans les 3 derniers mois.
     */
    get texteDernierBonTravailRecent(): string {
        const bonTravailRecent = this.dernierBonTravailRecent;
        if (!bonTravailRecent) {
            return '';
        }

        const numero = bonTravailRecent.numero || '---';
        const statut = bonTravailRecent.statut?.nom || '---';
        const date = this.formaterDateAffichage(bonTravailRecent.dateTravail || bonTravailRecent.dateCreation);

        return `Cette unité possède déjà un bon de travail récent (${numero}). Date : ${date} · Statut : ${statut}`;
    }

    /**
     * Formate une date en yyyy-MM-dd pour l'avertissement de bon de travail récent.
     */
    private formaterDateAffichage(date: Date | string | undefined): string {
        if (!date) {
            return '---';
        }

        const parsed = date instanceof Date ? date : new Date(date);
        if (isNaN(parsed.getTime())) {
            return '---';
        }

        return formatDate(parsed, 'yyyy-MM-dd', 'en-CA');
    }

    surChangementTypeBonTravail() {

    }

    /**
     * Mémorise le relevé de début sélectionné (heures ou KM) pour la création.
     */
    surReleveDebutHeureChange(releve: ReleveHeureEntite | null) {
        this.bonTravail.releveHeureDebut = releve ?? undefined;
        if (releve) {
            this.bonTravail.heuresDebutCompteur = releve.nbHeure;
        }
    }

    /**
     * Mémorise le relevé de KM de début sélectionné pour la création.
     */
    surReleveDebutKmChange(releve: ReleveKmEntite | null) {
        this.bonTravail.releveKmDebut = releve ?? undefined;
        if (releve) {
            this.bonTravail.kmDebutCompteur = releve.nbKm;
        }
    }

    /**
     * Crée le bon de travail à partir du formulaire.
     */
    CreerBonTravail() {

        this.submitted = true;
        this.messageService.clear();

        if (!this.validerNouveauBonTravail()) {
            this.messageService.add({ severity: 'error', summary: 'Erreurs', detail: 'Veuillez corriger les erreurs de saisie.' });
            return;
        }

        this.creationEnCours = true;
        this.bonTravail.type = this.selectionTypeBonTravail.cle;

        if (this.bonTravail.type == ETypeBonTravail.Interne) {
            if (this.bonTravail.mecanicien) {
                this.bonTravail.dateAssignation = new Date();
                this.bonTravail.statut = this.sdb.Statut(EStatuts.EnCours);
            } else {
                this.bonTravail.statut = this.sdb.Statut(EStatuts.EnAttente);
            }
        } else {
            if (this.bonTravail.fournisseur) {
                this.bonTravail.dateAssignation = new Date();
                this.bonTravail.statut = this.sdb.Statut(EStatuts.EnCours);
            } else {
                this.bonTravail.statut = this.sdb.Statut(EStatuts.EnAttente);
            }
        }

        this.bonTravailServie.Creer(this.payloadCreation()).then(x => {
            if (x.estUnSucces) {
                this.routerService.navigate([`mecanique/bontravails/${x.valeur.bonTravailId}`]);
            } else {
                x.messages.forEach(message => {
                    this.messageService.add({ severity: 'error', summary: 'Erreur', detail: message.description, sticky: true });
                });
            }
        }).finally(() => {
            this.creationEnCours = false;
        });
    }

    /**
     * Vérifie les champs obligatoires. Les heures et les KM ne sont pas comparés
     * au compteur courant : ils ne sont injectés qu'à l'approbation.
     */
    validerNouveauBonTravail(): boolean {
        return !!(this.bonTravail.dateTravail && this.bonTravail.contreMaitre && this.bonTravail.raison && this.bonTravail.item?.itemId);
    }

    /**
     * Envoie seulement l'identifiant du relevé lié, sans le graphe item/employé
     * qui peut empêcher la liaison d'être lue à la création.
     */
    private payloadCreation(): BonTravailEntite {
        return {
            ...this.bonTravail,
            releveHeureDebut: this.bonTravail.releveHeureDebut?.releveHeureId
                ? { releveHeureId: this.bonTravail.releveHeureDebut.releveHeureId }
                : undefined,
            releveKmDebut: this.bonTravail.releveKmDebut?.releveKmId
                ? { releveKmId: this.bonTravail.releveKmDebut.releveKmId }
                : undefined
        };
    }
}
